// export const API_URL = 'http://127.0.0.1:8000/app_dev.php'
export const API_URL = 'https://info-sites.mskobr.ru'
export default API_URL
